import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';

var StorageLocationList = createReactClass({
  propTypes: {
    storageLocations: PropTypes.array.isRequired
  },

  render() {
    var locations = this.props.storageLocations.map(location =>
      <tr key={location.id}>
        <td>
          {location.name}
        </td>
      </tr>
    );

    return (
      <div className="jarviswidget jarviswidget-color-blueDark" data-widget-editbutton="false">
                <header>
                    <span className="widget-icon"> <i className="fa fa fa-lg fa-inbox"></i> </span>
                    <h2>Lagerorte</h2>
                </header>
                <div>
                    <div className="jarviswidget-editbox"></div>
                    <div className="widget-body no-padding">
                        <div className="table-responsive">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Lagerort</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {locations}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
    );
  }

});

export default StorageLocationList;



// WEBPACK FOOTER //
// ./src/components/storagelocations/StorageLocationList.js